<template>
<span>
    <span class="dialog-content">
      <div>
        <p>
          {{$t('INDENT_RETURN_CREATED')}}
        </p>
        <p class="text-bold">
          <Route :sources="order.destinations" :destinations="order.sources" />
        </p>
      </div>
      <div class="mt-15">
        <p>
          {{$t('INDENT_CONSIGNEE')}}: <strong>{{order.sources[0].details.name}}</strong>
        </p>
        <p>
          {{$t('INDENT_TRANSPORTER')}} : <strong class="text-bold" v-if="order.transporter">{{order.transporter.name}}</strong>
        </p>
        <p>
          {{$t('INDENT_VEHICLE_TYPE')}} : <strong class="text-bold" v-if="order.vehicle_type">{{order.vehicle_type.name}}</strong>
        </p>
      </div>
    </span>
    <span slot="footer" class="dialog-footer">
      <Button type="secondary" size="mini" @click="$emit('closeDialog')">{{$t('INDENT_DISCARD')}}</Button>
      <Button type="primary" size="mini" @click="createReturnIndent">{{$t('INDENT_INDENT')}}</Button>
    </span>
  </span>
</template>
<script>
import Route from '@/components/orders/Route';

export default {
  components: {
    Route,
  },
  props: ['order'],
  methods: {
    async createReturnIndent() {
      try {
        const result = await this.$store.dispatch('order/addReturnIndent', this.order.order_number);
        if (!result || result.error) {
          this.$error({ message: this.$getErr('CREATE_RETURN_FAILURE') });
        } else {
          this.$success({
            message: this.$getSuccess('INDENT_CREATION', {
              firstArgument: result.order_no,
            }),
          });
          this.$emit('closeDialog', true);
        }
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
  },
};
</script>
